function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZimbabweQuick10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.6 499.7",
    style: {
      enableBackground: "new 0 0 489.6 499.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.7 54.1c-.9 1.5-2.2 1.4-3.5.6-.5-.3-.8-.8-1.3-1.2-1-.8-1.2-1.4 0-2.2.3-.2 1.2-.2 1-1-.2-.7-.9-.9-1.6-1-1.1-.2-2.2-.5-1.7-2.1 2.3 1.4 4.7 2.8 7 4.2.1.9-.6.8-1.2.9-.4.1-1 .1-1.1.7 0 .6.6.6 1 .6.6.1 1.1.1 1.4.5z",
    style: {
      fill: "#29106d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2 18.7c-1.8 2.7-4.5 3.5-7.1 2.1 1.3-.8 3.4 0 4-2.1h3.1z",
    style: {
      fill: "#36167d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.7 454.4c-.9-.5-1-1.5-.2-1.8 1.7-.8 3.5-1.8 5.2.2-1.6.5-3.2 1.3-5 1.6z",
    style: {
      fill: "#29106d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.7 54.1h-1c-.8-.1-2.1.3-2.1-1 .1-1 1.1-1.4 2.1-1.2.5.1.7-.1.9-.5.5 0 .9.3 1.2.7-1.2.1-1.5.8-1.1 2z",
    style: {
      fill: "#36167d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 409.9c1.5.4 3.3.6 3.2 2.8-1.2-.7-2.3-1.7-3.2-2.8zm6.4 5.5c1.7.3 3.2.9 3.5 2.8-1.3-.8-2.4-1.7-3.5-2.8z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6 49.7c.5.4 1.5.8.9 1.3-.7.7-1.6-.1-2.4-.5.5-.2 1-.5 1.5-.8z",
    style: {
      fill: "#431c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.3 455.1c-.4-.1-1-.1-1-.7 0-.3.3-.7.5-.8.9-.2 1.2.5 1.6 1.1-.2.4-.6.5-1.1.4z",
    style: {
      fill: "#29106d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 445.3c1.5-.2 2.9-.1 3.6 1.6-1.3-.3-2.5-.8-3.6-1.6zm-28.6-15.8c1.2 0 2.7-.4 2.7 1.7-1-.4-1.9-1-2.7-1.7zm13.2 8c1.4-.2 2.4.3 2.9 1.6-1-.4-2-.9-2.9-1.6z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1 431.2c.8.3 2.6-1.1 2 1.3-.7-.5-1.4-.9-2-1.3zm23.7 13.2c.6-1 1.4-.6 2.1-.2.3.2-.3.6-.6.7-.6-.1-1-.3-1.5-.5zm5.8 2.5c1.3-.5 2.2.1 2.8 1.2-1-.2-1.9-.6-2.8-1.2zm3.5 1.6c.2-.2.4-.3.6-.5.4-.3 1-.6 1.2 0 .2.7-.4.7-.9.8-.3 0-.7 0-.9-.3zm-41.4-22.8c1.9-.1 1.9-.1 1.7 1.1-.7-.2-1.2-.6-1.7-1.1zm26.1 15.7c1.2-.1 2.2.3 2.8 1.5-.9-.6-1.8-1-2.8-1.5z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 58c.7-.4 1.3-.7 2-1.1 7.4-4.3 14.9-8.4 22.8-11.9s16-6.6 24.2-9.2c7.8-2.5 15.7-4.4 23.7-6 8-1.6 16-2.5 24.1-3.2.3 0 .5-.1.8-.1 1.4-.7 3-.2 4.5-.4h20.3c.8 0 1.7-.1 2.5.3 7.4.2 14.7 1.2 22.1 2.3 9.9 1.5 19.5 3.7 29 6.6 11.7 3.5 23 8.1 33.9 13.5 5.7 2.8 11.1 6.2 16.7 9.2 4.6 3.1 9.2 6.1 13.7 9.4 25.1 18.3 45.3 40.9 60.8 67.8 8.2 14.3 14.7 29.3 19.4 45.1 4.3 14.4 7 29.1 8.3 44.1 1.3 15.1.9 30.1-1 45.1s-5.3 29.7-10.4 44c-9 25.5-22.3 48.6-39.9 69.2-1 1.2-2.1 2.3-3.1 3.5-.8 1-1.5 1.1-2.6.5-6.9-3.6-14-6.8-21.2-9.6-14.1-5.6-28.5-9.9-43.3-13.4h-.4c-.6-.6-1.6.2-2.2-.5-.8-.7-2 0-2.9-.7-.3.2-.5.1-.6-.1-1.8-.4-3.5-.7-5.3-1.1-12-1.5-23.8-4-35.8-5.2-7.2-.7-14.4-1.6-21.7-1.7-.6 0-1.2 0-1.7-.2l-.6-.3c-3-.7-6.1-.2-9.2-.3-8.3.1-16.5.1-24.8 0-5 0-9.9.3-14.9.7-1.7.1-3.4.1-5.1 0-1.7.1-3.5-.2-5.2.2-.4.1-.9.3-1.3.4-7.8.6-15.6 1.6-23.4 2.6-2.5.3-4.9.8-7.4 1.1-.3 0-.6.2-1 .2-3.1.5-6.3 1-9.4 1.2-1.9-.2-3.6.7-5.4.9-.7.6-1.6.6-2.4.7-.5 0-1 .1-1.5.1-.9.3-1.7 1.2-2.8.7-3.1.3-5.9 1.4-9 2-.6.1-1.1.3-1.7.4-.6.6-1.4.4-2 .7-.4 0-.7.1-1.1.1-.5.7-1.3.4-2 .7-4.5 1-9 2.2-13.4 3.9-.7.6-1.7.4-2.5.7-2.1-.1-4 1.1-5.9 1.8-3.2 1.2-6.4 2.2-9.5 3.5-4.2 1.7-8.4 3.4-12.6 5.3-3 1.3-5.9 2.8-8.8 4.2-.9.4-1.5.5-2.4-.4-13.7-15.6-25.1-32.7-34-51.5-5.4-11.5-9.8-23.4-13.1-35.7-3.4-12.7-5.6-25.7-6.7-38.8-.8-10.2-.9-20.3-.3-30.4.8-13.9 3-27.7 6.5-41.2 6.5-25.1 17.3-48.3 32.2-69.6.2-.3.3-.6.4-.9 4.1-5.3 8-10.7 12.4-15.7 13.6-15.7 29-29.4 46.5-40.7.3-.2.5-.4.7-.7 1.3-1 2.6-1.6 4-2.1z",
    style: {
      fill: "#fdf800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1 446.9c-5.8 1.8-11.7 3.7-17.7 5.1-8.7 2-17.5 3.9-26.5 4.8-4.8.5-9.6.8-14.4 1.2-5.2.4-10.5.3-15.7.3-6.6 0-13.1-.8-19.7-1.4-8.2-.8-16.2-2.3-24.2-4.1-5.4-1.2-10.7-2.6-16-4.4-3.6-1.2-7.2-2.3-10.8-3.4-2.1-.7-4-1.9-6.3-2-.2-.2-.5-.7-.7-.6-3.8.6-6.5-2.2-9.4-3.6-2.6-1.3-5.9-2.1-8-4.6-.7-.9-1.9-.8-2.8-1.3-5.1-3-10.1-6-15.1-9.3-3.7-2.5-7.4-5.1-11-7.7-4-2.9-8.1-5.9-11.7-9.3-1.8-1.7-3.8-3.3-5.4-5.2-2.4-2.7-5.8-4.3-7.6-7.7-.7-1.3-.1-1.7.6-2.1 1.4-.8 2.9-1.4 4.4-2.1 3.8-1.6 7.5-3.4 11.3-4.9 6.5-2.6 13.1-5.1 19.8-7.2 4.3-1.3 8.8-2.1 13-4.3 2.5-1.3 5.5-1 8.2-1.5 2.4-.5 4.8-1 7.1-2 2.4-1.1 4.9-1.7 7.6-1.9.7-.7 1.6-.9 2.5-.9.9 0 1.7-.2 2.4-.6 1.6-.9 3.3-.1 5-.3 6.8-.9 13.5-1.9 20.3-2.7 7.9-.9 15.9-1.5 23.9-2.1 10-.7 19.9-.7 29.9-.7 9.2 0 18.3.5 27.5 1.1 9.2.6 18.3 1.6 27.4 2.8 6.9 1 13.9 2.2 20.8 3.4.8.2 1.7.2 2.2 1.1 25.6 5 50.3 12.7 73.9 24.5-2.1 2.2-4.1 4.3-6.2 6.3-5.5 5.2-11.3 9.9-17.2 14.5-3.7 2.9-7.7 5.4-11.6 8.1-7.2 4.9-14.8 9.1-22.5 13.1-8.8 4.6-17.9 8.4-27.3 11.6z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.7 205.1c-3.7-21.9-10.4-42.7-20.3-62.6-14.4-28.7-34-53.2-58.8-73.6-7.5-6.1-15.3-11.9-23.6-16.8-1.7-.3-1.9.5-1.5 1.9l.1.1c-.4.1-.8.4-1.3.5-1.4.3-2.2-.7-3-1.6-.8-1 .2-1.3.7-1.9 1-1.2-.1-1.6-.9-2-.9-.5-2.2-.5-2.4-2-.2-.2-.4-.3-.6-.5-16-8.9-32.9-15.9-50.6-20.7-12.6-3.4-25.4-5.7-38.3-6.9-7.9-.7-15.9-1.2-23.9-.8-2.4-.1-4.7-.1-7 .3-1.7 1.9-3.9 2.4-6 2.2.9-.4 2.9.2 2.8-2.1-5 .2-10 .8-15 1.4-18.1 2.3-35.7 6.8-52.6 13.5-10.9 4.3-21.5 9.3-31.5 15.4-.5.1-.9.3-1.2.7.4 1.8-1.1.5-1.5.9l-4.5 2.7c-18 11.5-34.1 25.3-48.2 41.4-4.8 5.5-9.4 11.1-13.5 17.1-.3.3-.5.6-.8.9-12.7 17.9-22.6 37.3-29.6 58.1C21.8 194 18.2 218 18 242.6c-.1 16.6 2.6 32.9 5.8 49.1 3.8 19 10.7 36.8 19.7 53.9 10.6 20.2 23.9 38.4 40 54.6 3.3 3.3 6.6 6.7 10.3 9.6 1.3.6 2.5 1.4 3.2 2.8.9 1.1 2.1 1.8 3.2 2.7 1.4.7 2.7 1.4 3.5 2.8 3.4 2.5 6.5 5.3 10.1 7.5.6.2 1.4.3 1.7 1.1 1.2 1.1 2.5 2 4 2.7 1 .4 2.1.5 2.6 1.7.7.3 1.8.1 2 1.3 2.8 1.8 5.5 3.7 8.6 5 1.1.3 2.1.7 2.9 1.6 1.4.9 2.8 1.7 4.3 2.3 1 .3 2 .6 2.8 1.5 1.1.5 2.1 1 3.2 1.6.6-.2 1.3-.4 1.4.6.2.3.5.4.8.4 1.3.4 2.6.6 3.6 1.6 1.1.1 2 .6 2.8 1.2.2.3.5.3.8.3.1.5.9-.6.9.4 1.1.7 2.3 1.1 3.6 1.5.2.1.3.3.5.3 9.5 3.5 19 6.7 28.9 9.1 15.6 3.7 31.5 5.9 47.6 6.3 19.1.5 37.9-1.5 56.4-5.9 5.9-1.4 11.8-2.8 17.5-5-.1-.2-.4-.5-.2-.7.5-.4.9.3 1.4.3.5 0 .9-.1 1.2-.4-.2-.8.1-1.2.8-1.7 1.5-.9 2.8-.4 4.2 0 .6-.1 1.2-.3 1.6-.7.3-.1.6-.1.9-.2 32.3-12.2 60.4-30.8 84.2-55.8 16.8-17.6 30.2-37.6 40.5-59.7 12.9-27.9 19.7-57.2 20.6-87.8.2-14.6-.8-29-3.2-43.4zm-68.9 190.1c-1.9 1.9-3.9 3.7-5.9 5.5-10 9.5-21.1 17.7-32.8 24.9-13.4 8.2-27.4 15-42.3 20.1-.7.2-1.4.4-1.8 1.1-.7-.4-1.4 0-2.1.2-3.7 1.2-7.5 2.3-11.3 3.4-15.8 4.3-32 6.6-48.3 7.3-11.6.5-23.2-.1-34.7-1.7-17.3-2.3-34.1-6.5-50.5-12.6-1.2-.5-2.4-1.3-3.8-.6-.4-.9-1.2-1.1-2.1-1.1-1.3 0-2.4-.4-3.4-1.3-.6-.6-1.5-.9-2.3-1.1-1.1-.4-2.1-.6-3.1-1.2-3.4-2.2-7-4.1-10.6-5.9-3-1.5-5.7-3.5-8.6-5.1-1.5-.9-3.1-1.6-4.5-2.8-2.7-2.3-5.9-3.9-8.7-6.1-3.3-2.6-6.8-5-10.2-7.6-5-3.8-9.2-8.5-14-12.6-1.2-1.1-2.5-2.1-3.4-3.5-1.1-1.6-1-2 .8-2.8 3.6-1.6 7.2-3.4 10.9-4.9 3-1.2 5.9-2.4 8.9-3.6 7.7-3.1 15.7-5.5 23.7-7.8 2.6-.8 5-2.4 7.8-2.5 1.7-.1 3.4-.4 5.1-.7 4-.6 7.5-2.8 11.5-3.5.9-.2 1.8-.2 2.6-.8 0 0 0-.1.1-.1 1.7-.5 3.8.6 5.3-1.2.1-.2.7-.2.9-.1 1.7 1.3 3.5.1 5.2-.1 5-.5 10-1.5 15.1-2 5.7-.6 11.4-1.2 17.1-1.7 7.7-.7 15.4-1.2 23-1.4 14.9-.3 29.8-.3 44.7 1 5.3.5 10.5.8 15.8 1.3 6.6.7 13.2 1.7 19.7 2.7 4.9.8 9.8 1.8 14.7 2.7v.1c.6.5 1.3.6 2 .8 15.9 3.3 31.5 7.5 46.7 13.2 7.7 2.9 15.4 6.1 22.7 9.8 1.5.8 1.5.8.1 2.3zm62.9-135.5c-.9 10.5-2.5 20.9-4.8 31.2-2.1 9.2-4.8 18.1-8.1 26.9-4.7 12.5-10.5 24.5-17.4 35.9-6.7 11-14.2 21.4-22.8 31-1.9 2.1-1.9 2.2-4.4.9-13-6.6-26.5-11.8-40.3-16.1-7.6-2.4-15.3-4.6-23.2-6.2-.9-.1-1.7.2-2.6.4 0 0-.4.2-.2-.1.1-.1.3-.2.3-.4-.6-1-1.7-.7-2.6-.8-.6.1-.9.8-1.5.7.2-.3.8-.4.5-.9-1.6-.7-3.3-1.1-5-1.3-.4 0-.9 0-1.3.2-1.2-.3-2.4-.6-3.6-.8-9.1-1.6-18.3-3.1-27.5-4.1-9-1-18.1-2-27.2-2.3-.6-.4-1.4-.3-2.1-.3-2.3 0-4.6.1-6.8-.1l-.6-.3c-15.1-.1-30.2-.2-45.2.8-.1.1-.3.2-.5.3-1.8.2-3.7-.2-5.5.4-4.6.1-9.2.8-13.8 1.3-5.9.7-11.7 1.3-17.5 2.5 0 .2.2.4.1.4-.2.1-.3-.2-.5-.3-2.5.2-5.1.6-7.5 1.2-.6-.1-1.4.1-1.9 0-1.8 0-3.4.6-5.1 1-.8.8-1.6 1.7-2.9.8-.5-.1-.9-.1-1.3.1-1 .8-2 1.4-3.3.7-3.4.5-6.8 1.3-10.1 2.4-.5 1.4-1.5.5-2.3.6-.4 0-.7.1-1 .3-.5 1.3-1.5.6-2.4.5-2.9.5-5.6 1.4-8.4 2.3-1.6.5-3.3.7-4.7 1.7-.7.8-1.6.6-2.4.6-4.6.9-8.9 2.8-13.2 4.4-7.9 2.9-15.6 6.4-23.3 10-1.1.5-1.9.4-2.7-.6-2.7-3-5.2-6.1-7.7-9.2-9.7-12.3-17.9-25.4-24.7-39.4-5.5-11.4-10-23.1-13.4-35.2-4.5-16-7.1-32.4-7.9-49-.5-10-.2-20.1.8-30 .8-8 2-16 3.7-23.9C34 182.7 38.7 168 45.1 154c5.5-12.1 11.9-23.7 19.6-34.5.4-.5.8-1 1-1.7 0-.1-.1-.3-.1-.4 1-.2 1.3-1.1 1.8-1.8 4.6-6.2 9.4-12.3 14.6-18 7.3-7.9 15-15.4 23.4-22.1 5.6-4.5 11.4-8.7 17.3-12.9.9-.6 2.1-.9 2.7-1.9.4-1.8 1.4-2.7 3.3-2.2.8-.2 1.6-.5 1.9-1.5 0-.1.1-.2.1-.3 0 .1.1.3.1.4.6.1 1.1-.2 1.7-.5 2.3-1.4 4.7-2.6 7-3.9 15.5-8.5 31.8-14.9 48.9-19.3 10.5-2.7 21.1-4.7 31.9-5.6 2-.2 4.1-.3 6-1 1.4-.9 3-.3 4.5-.5s3 .5 4.4-.6c.2.1.3.2.4.4 1 .3 1.9.2 2.9.2 4.8.1 9.7-.1 14.5.1.1.1.3.3.5.4.6.3 1.3.3 1.9.3 3.9-.1 7.7.5 11.5 1 8.6 1 17.1 2.5 25.5 4.5 14.7 3.6 29 8.6 42.7 15.3 5.8 2.8 11.5 5.8 17 9.1.9.6 1.8 1.6 3.2 1.1h.2l-.2.2c.2.9.9 1.2 1.6 1.6 3 1.8 5.8 3.8 8.7 5.8 14.4 10.1 27.3 21.8 39 35 7.8 8.8 14.7 18.3 20.9 28.3 6.6 10.7 12.3 21.8 16.9 33.5 3.2 8.1 6 16.2 8.2 24.6 2.3 8.5 4 17.1 5.2 25.8 1.1 8.1 1.9 16.3 2 24.5-.4 7.3-.5 14.8-1.1 22.3zM122.1 431.2z",
    style: {
      fill: "#39177f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.3 363.4c.7.1 1.6-.2 2.2.5-.8-.1-1.5.2-2.3.3-.4 0-.9 0-.9-.5 0-.4.6-.2 1-.3zm-3.6-.8c.2 0 .4.1.6.1-.5 1-1.2 1.1-2.1.6.3-.8 1-.6 1.5-.7z",
    style: {
      fill: "#39177f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2 361.8c.7-.5 1.5-.7 2.4-.7-.5 1.6-1.1 1.8-2.4.7zm-4.3.9c.9-.2 1.8-.5 2.8-.7-.6 1-2 1.4-2.8.7zm2.5 2.2c-.5-.1-.6-.5-.5-.9.1-.5.4-.6.8-.6.3 0 .6.2.5.6-.1.5-.2.9-.8.9zm-15.2.8c.6-.5 1.3-.6 2-.7l.7 1.4c-1 .1-1.7-.9-2.7-.7zm-18.9 5.5c.7-.7 1.5-.8 2.5-.7-.5 1.4-1.6.6-2.5.7zm15.8-4.7c.6-.4 1.2-.7 2-.7-.1 1.8-1.1 1-2 .7z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4 25.7c1.6 0 3.1-.1 4.7-.1 5.9 0 11.8.1 17.7.1.1 0 .2 0 .3.1 0 .1-.1.2-.1.3-2.2.4-4.4.1-6.6.2h-15.7c-.3-.1-.4-.3-.3-.6z",
    style: {
      fill: "#503510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5 26.1H253l.3.3h-23c0-.1 0-.2.2-.3z",
    style: {
      fill: "#dec281"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5 26.1c-.1.1-.2.2-.2.3h-4.2c.4-1.3 1.5-.6 2.3-.7.7-.1 1.4 0 2.1 0v.4z",
    style: {
      fill: "#36167d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 58c-1 1-2.4 1.6-3.6 2.3.8-2.7 1.2-2.9 3.6-2.3z",
    style: {
      fill: "#431c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 188.4c1.8 1.3 2.7 2.7 2.8 4.7 0 1.1.6 1.6 1.5 2.2 1.3.8 2.3 2 3.4 3.1 1.3 1.3 2.7 1.6 4.4.8 1.6-.7 3.4-.9 5-.6 2.5.5 4.7-.1 7-1 1.8-.7 3.6-1.2 5.5-1.1.8 0 1.5.3 1.5 1.2 0 2.2 1.4 2.4 3 2.4 3.8-.1 4 .1 2.8 3.8-.4 1.3-.8 2.7-1.7 3.7-1.2 1.3-1.1 2.6 0 3.8 2.2 2.4 2.8 5.7 2.8 8.5 0 2.9.4 6.2-2.6 8.7-3.5 3-4.3 7.1-2.4 11.6 1.2 2.8 1 5.6.6 8.5-.2 1.5-.1 2.8 1 4 1.6 1.7 1.6 4 1.9 6.1.3 2.1-1.2 3.2-3.4 3.2H62.6c-2.5 0-2.5 0-1.7-2.3 4.5-13.5 9.1-27.1 13.6-40.6 3.5-10.3 7-20.4 10.5-30.7z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 182.1c-2.9 1.7-5.5 3.1-8 4.6-12.6 7.5-20.6 18.6-25.3 32.3-2.3 6.9-4.4 13.8-7.7 20.3-3.7 7.1-10.1 13.2-17.3 16.1.3-1.8.6-3.4.9-5 3.3-17.4 2-34.5-5-50.8-5.6-13.1-14.3-23.7-27.3-30.2-6.8-3.4-14-5-21.5-5.5-.4 0-.8-.1-1.3-.2 1-1.4 2.4-1.7 3.7-2.3 8.8-3.9 17.9-4.6 27.3-2.4 14.3 3.4 24.9 12.1 33.7 23.5 2.7 3.5 5 7.2 7.2 11 .6 1.1.9 1.4 1.9.3 3-3.4 6.1-6.6 9.8-9.3 5.9-4.2 12.6-4.8 19.5-4.2 2.9.5 5.9 1 9.4 1.8z",
    style: {
      fill: "#f31019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.5 224.4-7.5 22.5c-1.5 4.3-3 8.6-4.3 13-.5 1.5-1 2.1-2.7 2.1-22.9-.1-45.7 0-68.6 0h-2.2c-.1-.2-.1-.3-.2-.5 5-.9 7.9-4.9 11.6-7.8 1.1-.9 1.8-2.3 2-3.7.2-1.2.8-1.8 1.9-2.2 3.6-1.3 4.4-2.5 4-6.3-.1-1.4.3-2.2 1.4-3.2 1.9-1.7 4-2.7 6.3-3.7 2.6-1.1 4.1-3.1 4.5-5.9.3-2.4.8-4.8-.4-7.1-.3-.6-.2-1.3.2-1.9.2-.3.6-.5.3-.8-1.6-1.6.1-2.3.9-3.3 4.7-5.6 10.9-9.6 16.5-14.1 1-.8 2-1.6 3.4-2.8-1.3 4-2.5 7.4-3.7 10.9-1.4 4.3-2.8 8.7-4.2 13 .2.2.4.3.6.4 12.4.1 24.9 0 37.3.1h2c.8-.1 1.1.4.9 1.3zm-15.1-79.8c-1.4 4.3-2.8 8.7-4.2 13-2.3 6.9-4.6 13.7-7 20.6-.5 1.4-.6 2.5-2.9 1.9-5.6-1.5-11.4-2.6-17.2-2.5-.9 0-1.2-.3-1-1.1.3-1.8.2-3.3-.8-5.1-1-1.6-1.1-4-1.4-6-.2-1.2 1.5-1.8 1.9-3 .2-.6.7-1.1.7-1.8.1-1.2-.1-2-1.7-1.9-.9.1-1.9 0-2.8-.6-.7-.5-1.6-.2-2.4.1-2.9 1.3-4.2.9-6-1.8-2-2.9-4.6-5.1-8.2-5.8-4.7-1-8.4.6-11.6 3.9-1.1 1.2-4 .9-4.7-.6-.3-.6.2-.8.7-.9 2.4-.7.4-2.4.7-3.6.1-.7-1.2-.8-2.1-.6-2.4.5-4.8.4-7.2.5-3.2.2-6.3.6-9.1 2-1 .5-1.9 1.1-3.3.4-1.1-.5-2.6.5-3.8-.7-.2-.3-.9.4-1.2.8-2.4 2.8-5.3 4.4-9.1 3.7-1.1-.2-2.2-.1-3.3-.1-1.1.1-1.4-.3-1-1.4 1.3-3.7 2.6-7.5 3.9-11.2.7-.4 1.5-.3 2.3-.3h99.7c2.3.1 2.4.1 2.1 2.1zm151.5 123.6c-7.7-.8-13.3-7.9-12.3-15.9 1.5-11.6 8.1-19.6 18.1-25 5.5-3 11.3-4.1 17.6-3.3 8.7 1.1 14.1 7.9 12.8 16.6-1.8 12-9 20-19.6 25.2-2.6 1.3-5.2 2.3-8.2 2.4-2.8.6-5.6.5-8.4 0zM259.6 224c8.5.9 14.2 7.5 12.8 16.9-1.6 10.5-7.6 17.9-16.5 23.3-3.5 2.1-7.2 3.6-11.3 4-2.7.5-5.4.5-8.1 0-6.9-.5-12.4-6.3-12.6-13.3-.2-9 3.9-16.1 10.2-22.1 4.5-4.3 9.9-7 15.9-8.5.8-.2 1.6-.2 2.3-.2 2.5-.6 4.9-.6 7.3-.1z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3 213.1c2-5.6 3.8-11 5.7-16.3 2.8-8.1 5.7-16.2 8.4-24.3.6-1.8 1.4-2.4 3.3-2.3 5.8.1 11.5 0 17.3.1 2.9 0 5.9.3 8.6 1.7 3.1 1.5 4.6 4.1 4.4 7.3-.4 6.6-3.2 12.1-9.3 15.4-.2.1-.5.3-.7.4-3.1 1.2-3.1 1.1-2.1 4.4 1.3 4.2 2.5 8.4 3.9 12.6.3.9.2 1.3-.9 1.3h-15c-1 0-1.3-.5-1.4-1.4-.6-3.9-1.3-7.7-2.1-12-1.4 2.7-2 5.2-2.9 7.6-.8 1.9-.8 4.5-2.3 5.5-1.4.9-3.8.3-5.8.3-2.9-.3-5.9-.3-9.1-.3zm99.7 0c3.8-5.4 7.4-10.4 10.9-15.4 6.1-8.7 12.3-17.4 18.4-26.1.7-1 1.3-1.4 2.5-1.4 4.7.1 9.3.1 14 0 1.4 0 1.8.5 1.7 1.8-.1 13.2-.1 26.3 0 39.5 0 1.3-.4 1.6-1.7 1.6-4.5-.1-8.9-.1-13.4 0-1.4 0-1.6-.6-1.5-1.7.2-3.7.2-3.7-3.5-3.7-1.6 0-3.2.2-4.7 0-2.2-.3-3.6.5-4.2 2.5-.9 2.6-2.7 3.2-5.3 3.1-4.2-.3-8.5-.2-13.2-.2zm-183.4 0c3.2-4.5 6.1-8.7 9-12.8 6.7-9.5 13.5-19 20.1-28.5.8-1.2 1.7-1.6 3.1-1.6 4.6.1 9.2.1 13.8 0 1.1 0 1.6.2 1.6 1.5-.1 13.2-.1 26.4-.1 39.5 0 1.5-.4 1.9-1.8 1.9-4.3-.1-8.7-.1-13 0-1.5 0-1.9-.4-1.7-1.9.5-3.6.4-3.6-3.2-3.6-2 0-4.1.1-6.1 0-1.2-.1-2.1.3-2.5 1.4-1.2 3.3-3.4 4.5-7 4.1-3.9-.3-7.8 0-12.2 0zM380.4 196c-2.1 5.6-4.1 10.6-6 15.7-.2.5-.6.6-1 .8-6 2.1-12 2.8-18 .3-6.2-2.6-9.6-8.9-8.3-15.5 2.6-13.5 10.7-22.3 23.7-26.7 5.3-1.8 10.7-2 16.1 0 1.4.5 1.9 1 1.3 2.5-1.6 4.1-3 8.4-4.4 12.6-.2.5-.2 1-.8 1.4-1.3-1.3-2.6-2.6-4.5-3.2-6.1-2.1-14.4 3.1-14.8 11.3-.1 2.5 1.4 4.1 3.9 4.6 4.2.8 7.6-1.1 11.1-2.8.3-.3.7-.5 1.7-1zm-109.7-25.8c4.3 0 8.5.1 12.8 0 1.4 0 1.7.4 1.2 1.7-1.1 2.9-2.2 5.8-3.1 8.7-.4 1.2-1 1.5-2.1 1.5-3.3-.1-6.7 0-10 0-1.3 0-3.5 3.2-3 4.4.3.6.9.4 1.4.4 2.9 0 5.8.1 8.7 0 1.4 0 1.6.4 1.1 1.6-1 2.8-2 5.5-3 8.3-.3 1.1-.9 1.4-2 1.4-3-.1-6 0-9 0-1.1 0-1.6.3-1.9 1.4-1.3 4.1-2.9 8.1-4.3 12.2-.4 1.1-.9 1.5-2.1 1.5-4.1-.1-8.3-.1-12.4 0-1.4 0-1.5-.4-1.1-1.6 4.7-13.3 9.3-26.5 14-39.8.4-1.2 1-1.6 2.2-1.6 4.2 0 8.4-.1 12.6-.1z",
    style: {
      fill: "#f31019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6 239.1c-2.5 7.1-5 14.1-7.5 21.2-.7 2-1.4 4-2.1 6.1-.3.7-.6 1.2-1.5 1.2-4.3-.1-8.7-.1-13 0-1.5 0-1.2-.7-.9-1.6 2.5-7.2 5.1-14.4 7.6-21.6.2-.6.3-1.1.5-1.7 1.2-3.9 1.2-3.9-2.9-3.9s-4.1 0-2.8-3.9c1-3 2.1-5.9 3-8.9.3-1 .8-1.3 1.8-1.3h29.5c1.3 0 1.8.2 1.2 1.6-1.5 4-2.9 8-4.3 11.9-2.6.7-5.2.1-7.8.4-.3.1-.6.2-.8.5zm-34.4-.1-5.4 15-4.2 12c-.4 1.1-1 1.5-2.1 1.5-3.9-.1-7.9-.1-11.8 0-1.8.1-2-.4-1.5-2.1 3.1-8.6 6.2-17.3 9.2-26v-.4c-.1-.2-.3-.3-.5-.4-1.9-.1-3.8 0-5.7-.1-.6 0-1.5.3-1.7-.8 1.4-4.1 2.8-8.1 4.1-12.2.2-.7.7-.9 1.3-.9H314c.1 0 .2.1.5.2-1.6 4.4-3.1 8.8-4.7 13.2-1.7.8-3.4.2-5.1.4-1 .1-1.9 0-2.9.1-.2.3-.4.4-.6.5z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.8 308.3c-.8 2.4-.8 2.4 1.6 2.4h10.2c1.4 0 2.3.1 1.6 1.9-.1.3 0 .8 0 1.7 4.3-6.7 8.4-13 12.5-19.3 1.4-.7 2.8-.3 4.2-.4 2-.1 4-.1 6.1 0 .2 0 .5.2.6.3 1.5 7 3 14 4.5 21.3h-8.2c-.8 0-1.1-.4-1.1-1 0-1.4-.9-1.5-2-1.5-1.6 0-3.3.1-4.9 0-1.5-.1-2.7.2-3.2 1.7-.3.8-.9.8-1.6.8h-29.3c-1.3 0-1.4-.5-1.2-1.5 1.4-6.4 2.8-12.7 4.2-19.1.4-.8 1-1 1.9-1h19.6c.6 0 1.2-.1 1.6.6 0 .6-.5.9-.6 1.6-.2 3-.3 3-3.2 3-3.3 0-6.6.1-9.8-.1-1.8-.1-2.2.7-2.2 2.1 0 1.6 1.3.9 2 1 3.1.1 6.3.1 9.4 0 1.3 0 1.8.2 1.4 1.6-.3 1.1-.5 2.1-.8 3.2-.7.6-1.5.4-2.2.4-3.5.1-7-.1-10.5.1-.2 0-.4.1-.6.2z",
    style: {
      fill: "#4d3493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5 213.1c1.7-5 3.4-9.7 5-14.4 3.1-8.8 6.2-17.5 9.2-26.3.5-1.6 1.2-2.3 3-2.2 4.1.2 8.1.1 12.2 0 1.1 0 1.4.1 1 1.3-4.7 13.3-9.4 26.6-14.1 40-.4 1.3-1 1.7-2.4 1.6h-13.9z",
    style: {
      fill: "#f31019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 294.5h22.4c1.3 0 1.8.1 1.5 1.7-.8 3.8-.7 3.8-4.6 3.8-4.2 0-4.2 0-5 4.2-.7 3.7-1.6 7.3-2.3 10.9-.2.8-.5 1.1-1.3 1.1-2.1 0-4.2-.1-6.3 0-1.1 0-1.4-.3-1.1-1.3.8-3.4 1.4-6.8 2.1-10.2l.3-1.5c.6-3.1.6-3.2-2.7-3.2h-10.4c-1.2 0-1.7.4-1.9 1.6-.8 4.4-1.9 8.7-2.8 13.1-.2 1.1-.7 1.6-1.9 1.6-1.8-.1-3.7-.1-5.5 0-1.1 0-1.6-.1-1.3-1.5 1-4.2 1.8-8.4 2.8-12.7.3-1.5.2-2.2-1.6-2.1-1.5.1-3 0-4.5 0-1.1 0-1.3-.4-1.1-1.4 1.2-5 .1-4.1 5-4.1 6.6-.1 13.4-.1 20.2 0zm39.6-.8c2.9-.1 5.8 0 8.5 1.1s4.3 3.2 4.4 6.1c.3 8.2-3.7 15.1-14.3 15.9-4 .3-8.1.5-11.9-1.4-2.7-1.3-4.1-3.5-4.1-6.4.1-8.8 4.6-14.7 14.3-15.4 1 .1 2.1.1 3.1.1zm-79.5-.1c2.1-.1 4.2.2 6.3.6 4.1.7 6.7 3.6 6.6 7.8-.3 8.9-4.9 14-13.9 14.9-4.3.4-8.7.6-12.7-1.5-2.1-1.1-3.5-2.9-3.7-5.4-.6-7.3 2.9-15.5 14.3-16.2 1-.1 2-.1 3.1-.2z",
    style: {
      fill: "#f31119"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.3 309.9c-.4 1.7-.9 3.4-1.2 5.1-.2 1.1-.7 1.2-1.6 1.2-1.9 0-3.8-.1-5.7 0-1.4.1-1.7-.5-1.4-1.7.9-4 1.7-7.9 2.6-11.9.6-2.6 1.1-5.2 1.7-7.8.6-.4 1.2-.4 1.9-.4h18.1c.7 0 1.4 0 2.1.3 2.2.7 3.2 2.2 3 4.7-.3 2.7-1.5 4.6-4 5.8 1.5 1.2 1.5 2.8 1.2 4.5-.3 1.8-.9 3.6-.4 5.4.3.9-.3.8-.8.8h-7.3c-.9 0-1.2-.4-1-1.2.2-1.1.3-2.2.4-3.3.1-.7.2-1.4-.6-1.9-.1-.1-.3-.2-.5-.3-2-.1-4-.1-6 0-.2.4-.4.5-.5.7z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2 307.5c-4.8 0-4.8 0-5.6 4.7-.7 3.9-.7 3.9-4.7 3.9h-2.6c-2.3 0-2.3 0-1.8-2.2 1.2-5.8 2.5-11.6 3.7-17.5.3-1.5.8-2.3 2.5-2.1 1.6.2 3.3.1 4.9 0 1.4-.1 1.7.6 1.4 1.8-.3 1.3-.5 2.7-.9 4-.5 1.5.1 1.8 1.5 1.8 2-.1 4.1-.1 6.1 0 1.1 0 1.7-.2 1.8-1.4.2-1.5.7-3.1 1-4.6.2-1.1.6-1.6 1.8-1.5 1.8.1 3.7.1 5.5 0 1.3-.1 1.7.3 1.4 1.7-1.1 5-2.1 10.1-3.3 15.1-.4 1.7 0 4-1.5 4.8-1.4.7-3.5.2-5.2.2-3 0-3 0-2.3-2.8.3-1.5.6-3.1 1-4.6.2-.9-.1-1.3-1.1-1.3-1.2.1-2.4 0-3.6 0z",
    style: {
      fill: "#f31019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6 316.2c-3.3 0-6.7-.1-10 0-1.3 0-1.5-.5-1.3-1.6 1.3-6.2 2.7-12.4 4-18.6.2-1 .6-1.6 1.8-1.5 6.8.1 13.5.1 20.3 0 1.1 0 1.5.3 1.1 1.3v.2c-.4 3.7-.4 3.7-4.1 3.7-3.2 0-6.4.1-9.6 0-1.3 0-1.7.5-1.9 1.6-.2 1 0 1.4 1.1 1.4 3.3-.1 6.7 0 10 0 1.5 0 2.1.2 1.6 1.9-.9 3.3-.8 3.4-4.4 3.4h-8.1c-1.2 0-2 .2-2 1.7-.1 1.7 1.1 1.1 1.9 1.1 3.6.1 7.2.1 10.8 0 1.2 0 1.6.2 1.3 1.6-.9 3.9-.8 3.9-4.7 3.9-2.7-.1-5.2-.1-7.8-.1z",
    style: {
      fill: "#f31119"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4 167.8c.2 4.1-.9 7.7-3.5 10.7-3.7 4.3-9.2 4.8-13.6 1.2-6.5-5.3-7.1-18-1-23.9 4.8-4.6 12-3.4 15.6 2.6 1.8 2.9 2.8 6.1 2.5 9.4z",
    style: {
      fill: "#f31019"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 294.4h10.6c1.2 0 1.8 0 1.5 1.6-.8 4-.7 4-4.7 4-4.1 0-4.1 0-4.9 4-.8 3.7-1.6 7.4-2.3 11.1-.1.7-.3 1.1-1.1 1.1h-6.9c-1.2 0-.8-.7-.7-1.3.9-4.2 1.8-8.5 2.7-12.7.5-2.2.5-2.2-1.8-2.2h-2.8c-3.4 0-2.8.4-2.3-3 .3-2.1 1.2-2.7 3.3-2.6 3.1.2 6.2.1 9.4 0 0 .1 0 0 0 0zm208 21.8h-9.6c-1 0-1.4-.2-1.1-1.3 1.4-6.2 2.7-12.4 4-18.6.3-1.5.9-1.9 2.4-1.9 1.8.1 3.5.1 5.3 0 1.2 0 1.5.3 1.2 1.5-1 4.1-1.7 8.2-2.7 12.3-.4 1.6 0 2.1 1.6 2 3.1-.1 6.3 0 9.4-.1 1.1 0 1.8 0 1.5 1.6-.9 4.4-.8 4.4-5.2 4.4-2.3.1-4.5.1-6.8.1z",
    style: {
      fill: "#f31119"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.1 310.7c-.3 1.5-.6 3.1-.8 4.6-.1.8-.6.9-1.3.9h-19.7c-1.3 0-1.2-.7-1-1.5.9-4.1 1.8-8.2 2.6-12.3.5-2.5 1.1-5 1.6-7.6 2.6-.8 5.2-.3 7.7-.3.6 0 .9.5.6 1.2-.8 4.3-1.7 8.6-2.5 12.9-.1.6-.3 1.2.5 1.5 3.3.1 6.6 0 9.9.1.9.1 1.7-.1 2.4.5z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4 144.6c.2-1.9-1.2-1.6-2.3-1.6H100.2c.1-.1.1-.3.2-.4.6-.2 1.3-.1 1.9-.1H203c.6 0 1.3-.1 1.9.1.3.8 0 1.4-.5 2z",
    style: {
      fill: "#523d48"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1 142.6h-76.7c-9.3 0-18.6 0-27.9-.1.5-.6 1.2-.3 1.8-.3h100.9c.7 0 1.4-.3 1.9.4z",
    style: {
      fill: "#9f8895"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5 190.5c-.6-.1-1.7.1-1.9-.7-.2-.8.9-1 1.4-1.3 2.5-1.7 5.2-2.8 7.8-4.3.3-.2.8-.4 1.1-.1.4.3.1.8 0 1.1-.3 1.1-.7 2.2-1.1 3.3-.6 1.5-2.1 1.3-3.3 1.6-1.2.4-2.5.3-4 .4z",
    style: {
      fill: "#50368f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.5 224.4c0-1.4-1-1.1-1.8-1.1h-37.4c-.6 0-1.3.3-1.8-.4.4-.3.9-.2 1.3-.2h38.8c.4 0 .8 0 1.1.2.2.5.2 1.1-.2 1.5z",
    style: {
      fill: "#887001"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7 222.9h-41.3c0-.1 0-.3.1-.4h39c.7 0 1.6-.3 2.2.4z",
    style: {
      fill: "#fce363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9 295.1c-4.8-.4-9.5-.1-14.3-.2h-6.7c-.8 0-1.5.1-2.1.6.1-.4.1-.7.2-1.1 5.7-.3 11.4-.1 17.1-.1 2 0 3.9-.2 5.9.2 0 .2-.1.4-.1.6z",
    style: {
      fill: "#5a4525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 294.5c-7.7 0-15.3 0-23-.1.3-.5.8-.3 1.2-.3h20.3c.6.1 1.2-.2 1.5.4z",
    style: {
      fill: "#cbb38d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8 294.9h-22.1c0-.1.1-.3.1-.4 1.7-.4 3.5-.2 5.3-.2h14.3c.6 0 1.3-.2 1.9.2.2.2.3.3.5.4z",
    style: {
      fill: "#5a4621"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3 294.6h-21.5c.2-.4.6-.4 1-.4H192c.5 0 1.1-.2 1.3.4z",
    style: {
      fill: "#cdb689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 310.3c-.2-.6-.3-1.1.2-1.6-.1 1.1.6 1.2 1.5 1.2h9.4c.6 0 1.3-.3 1.8.4-4.3.3-8.6.2-12.9 0z",
    style: {
      fill: "#ccb18d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.8 307.9c.5-.7 1.2-.3 1.8-.4h11.5v.4c-4.4.3-8.8.4-13.3 0z",
    style: {
      fill: "#604903"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.8 307.9h13.3c-.5.7-1.2.4-1.8.4h-11.6c.1-.1.1-.2.1-.4z",
    style: {
      fill: "#f8df8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 310.3c4.3 0 8.5 0 12.8-.1v.4h-10.8c-.6.1-1.4.4-2-.3z",
    style: {
      fill: "#5c4424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6 294.9h-.2c-2.3-.5-4.6-.1-7-.2-1.2-.1-2.5.2-3.7-.2 1.3-.8 2.8-.3 4.1-.4 1.8-.1 3.6 0 5.5 0 .6.1 1.4-.2 1.3.8z",
    style: {
      fill: "#ccb488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8 294.5h8.8c.6 0 1.3-.3 1.8.4-3.6 0-7.2 0-10.7-.1.1 0 .1-.1.1-.3z",
    style: {
      fill: "#5a4521"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1 353.9c-3.1-.1-6.2.5-9.3-.4 3-.2 6.1-.4 9.1.1.1.1.1.2.2.3z",
    style: {
      fill: "#5c450b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9 353.7c-3 0-6.1-.1-9.1-.1-.1-.1-.2-.2-.2-.3h8.5c.3-.1.7 0 .8.4z",
    style: {
      fill: "#e3ca81"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 295.8c-.1-1.1-.9-.9-1.6-.9h-6.8c0-.1.1-.3.1-.4 2.8-.3 5.6-.2 8.4-.1.2.5.3 1-.1 1.4z",
    style: {
      fill: "#5d481d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6 239.1c.1-.2.2-.3.3-.5 2.8-.2 5.5-.3 8.3.1-1.8.8-3.8.2-5.7.4h-2.9z",
    style: {
      fill: "#cbb28d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 237.8c1.6.9 3.3.2 4.9.4 1 .1 2.1-.3 3 .4-2.7.4-5.4.3-8.1.1-.1-.3-.1-.6.2-.9z",
    style: {
      fill: "#5d4520"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2 238.7c1.6-.9 3.3-.2 4.9-.4 1.2-.1 2.5 0 3.7 0v.3c-2.8.4-5.7.3-8.6.1z",
    style: {
      fill: "#5d4421"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2 238.7h8.6c-1.2.9-2.5.3-3.7.4-1.6.1-3.3 0-4.9 0v-.4z",
    style: {
      fill: "#cdb38b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1 294.5c-2.8 0-5.6 0-8.4.1 2.8-.7 5.6-.7 8.4-.1z",
    style: {
      fill: "#ceb97d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1 238.7c-2.8 0-5.5 0-8.3-.1 2.8-.7 5.6-.2 8.4-.3 0 .2 0 .3-.1.4z",
    style: {
      fill: "#5d4321"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3 238.7c2.7 0 5.4 0 8.1-.1v.5c-2.1 0-4.2 0-6.3-.1-.5 0-1.2.3-1.8-.3z",
    style: {
      fill: "#ccb38d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9 268.2h8.4c-.2.1-.3.2-.5.3-2.4.3-4.9.3-7.3 0-.3 0-.4-.1-.6-.3z",
    style: {
      fill: "#6a5211"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.6 268.2h8.1l-.6.3c-2.4.3-4.9.3-7.3 0-.1 0-.2-.1-.2-.3z",
    style: {
      fill: "#6a5213"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8 268.6h7.3c-2.4.7-4.9.6-7.3 0z",
    style: {
      fill: "#e4c87d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4 268.6h7.3c-2.4.6-4.8.7-7.3 0z",
    style: {
      fill: "#e2c87b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.3 309.9v-.4c2.3-.2 4.6-.3 6.8.1 0 .1.1.2.1.3h-6.9z",
    style: {
      fill: "#efdd8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6 224h-7.2c0-.1.1-.2.1-.3 2.3-.4 4.6-.3 7 0 0 .1.1.2.1.3z",
    style: {
      fill: "#796103"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.5 223.7h-7c2.3-.7 4.7-.6 7 0z",
    style: {
      fill: "#fce271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.1 354.3c-.6.4-.6.4-1.3.4h-4.4l.9-.3c1.6-.4 3.2-.3 4.8-.1z",
    style: {
      fill: "#63470e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.1 354.3h-4.9c1.7-.8 3.4-.3 5.1-.3 0 .1-.1.2-.2.3z",
    style: {
      fill: "#ebce78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 358.5c.4.1.8.3 1.3.4-1.1.6-1.1.6-1.7-.3.1 0 .3-.1.4-.1z",
    style: {
      fill: "#4d3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3 408c1.2-3.4 2.6-6.7 3.7-10.1.6-1.9 1.9-1.5 3.1-1.4 1.4.1.7 1.3.7 2 .1 3.1 0 6.2 0 9.1.9-2.5 1.8-5.3 2.8-8 1.1-3.3 1.1-3.3 4.7-3.1.3.3.1.6 0 .9-2 4.8-4 9.7-6 14.5-.5 1.3-2.4 1.9-4.2 1.3-1.3-.4-.6-1.6-.6-2.3 0-2.2.2-4.4.1-6.7-1 2.6-2 5.2-2.9 7.7-.5 1.3-2.2 1.8-4.1 1.3-1.3-.3-.8-1.4-.8-2.1.3-4.4.2-8.8.1-13.2 0-2.5 1.7-1.2 2.7-1.5 1.4-.3 1.4.6 1.3 1.6-.3 3.3-.5 6.5-.7 9.8 0 .1.1.2.1.2z",
    style: {
      fill: "#fefdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7 396c.8.1 1.6 0 2.3.2 1.8.4 2.8 1.5 2.5 3.4-.6 4.4-2 8.6-2.5 13.1-.1.7-3.1 1-3.6.3-.6-1-1-.4-1.4 0-1 .7-2.2.8-3.4.7-1.8-.2-2.6-1.2-2.7-3 0-3.3 1.5-5.6 4.5-6.9 1.1-.5 2.3-.9 3.4-1.4.9-.4 1.7-1.1 1.7-2.2 0-.7-.5-.9-1-.9-1.1-.1-2.1.1-2.6 1.3-.2.6-.4 1.3-1.3 1.2-.9-.1-2.1.5-2.6-.3-.5-.9.3-1.9.8-2.7 1.5-2.3 3.6-2.8 5.9-2.8zm-54 0c4.2 0 5.2 1.3 4.4 5.4-.7 3.6-1.7 7.1-2.1 10.8-.1.6-.2 1.1-.9 1-1-.1-2.4.6-2.8-.5-.5-1.2-.8-.4-1.1-.1-1.2.9-2.5 1.1-3.9.9-1.6-.2-2.4-1.3-2.4-2.8 0-2.9 1-5.4 3.9-6.7l3.6-1.5c.2-.1.5-.2.7-.3.9-.5 1.5-1.1 1.5-2.2 0-.6-.4-.8-.9-.8-1.1-.1-2.2-.1-2.7 1.1-.4.8-.6 1.6-1.7 1.3-.8-.1-1.8.4-2.2-.3-.4-.7.2-1.6.6-2.3 1.2-2.5 3.5-3 6-3z",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 413.6c-3.9 0-5-1.1-4.7-4.9.3-3.1.9-6.1 2.1-8.9 1.4-3.4 6.1-5 9.3-3.3 1.4.8 1.7 2.1 1.6 3.5-.2 3.1-.8 6.2-1.8 9.2-1.1 3.3-2.8 4.4-6.5 4.4z",
    style: {
      fill: "#fefdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5 413.6c-4.1-.1-5.3-1.5-4.6-5.5.5-2.7 1-5.4 1.9-8 1.5-4.2 5.6-4.7 9.1-3.7 1.5.4 2 1.7 2 3-.1 3.6-.8 7.1-2.1 10.5-1.1 2.9-3.4 3.9-6.3 3.7zm-22.8-12.7c-.3 2.8-.8 6.1-2.1 9.1-1.4 3.4-6.3 4.9-9.5 3.1-1-.6-1.5-1.4-1.5-2.6 0-4 .8-7.8 2.5-11.4 1.4-3 6.6-4.2 9.3-2.4 1.4 1 1.3 2.4 1.3 4.2zm50.5-4.9c3.4.1 4.7 1.8 4.1 5.1-.4 2.2-2.1 1-3.1 1.2-1.5.2-.8-1-.8-1.6 0-.6.2-1.2-.6-1.5-.7-.3-1.3 0-1.6.7-1.2 3-1.6 6.3-2.2 9.5-.1.5.3.9.7 1.1.6.3 1-.1 1.3-.5.5-.6.6-1.4.8-2.2.2-.7.4-1.2 1.3-1.1 3.4.2 3.2-.6 2.2 2.9-1.1 3.5-5.1 5.1-8.5 3.6-1.2-.6-1.8-1.6-1.8-2.8.3-4 .9-7.9 2.6-11.6 1.2-2.2 3.3-2.9 5.6-2.8zm-95.6 17.6c-3.2.1-4.8-1.4-4.3-4.5.4-2.9 1-5.8 1.8-8.6 1-3.6 4.3-5.3 7.9-4.3 2.3.6 3.5 3.5 2.2 5.6-.8 1.3-2.3.6-3.4.5-1.1-.1-.2-1-.2-1.5 0-.6.2-1.2-.5-1.5-.8-.3-1.5.1-1.8.8-1.1 3-1.7 6.2-2 9.3-.1.5.1.9.6 1.1.6.2 1.1 0 1.4-.5.4-.7.7-1.4.8-2.2.1-.9.6-1.1 1.4-1.2 2.8-.1 3 .2 2.1 2.9-.9 2.8-2.6 3.9-6 4.1zm128.8-3.4h4.1c.5 0 1.6-.4 1.4.7-.2.8.3 2.2-1.2 2.3-2.8.1-5.6 0-8.5 0-.9 0-.9-.5-.8-1.2.2-1.3.7-2.5 1.6-3.5 2.2-2.9 4.4-5.8 6.9-9-1.6 0-2.8.1-4 0-.5 0-1.6.5-1.4-.6.1-.9-.3-2.4 1.3-2.4 2.8-.1 5.6 0 8.5 0 .8 0 .8.4.7 1-.2 1.1-.5 2-1.2 2.9-2.1 2.7-4.2 5.4-6.2 8.1-.6.4-1.2.8-1.2 1.7zm-157.7 3c-1.9.4-2-.5-1.6-2 .8-3.3 1.5-6.6 2.2-9.9.1-.7.9-1.8-.7-2.1-.5-.1.1-2.6.6-2.6 1.4 0 1.3-1 1.5-1.9.7-2.8 2-3.8 4.9-3.7.5 0 1.4-.4 1.3.5-.1.9.1 2.2-.9 2.4-1 .2-1.2.6-1.5 1.5-.3 1 .3.9 1 1.2.7.3.2 2.6-.7 2.6-1.2.1-1.2.9-1.4 1.7-.7 3.5-1.6 7-2.2 10.5-.4 1.6-1 2.1-2.5 1.8zm81.4-21.3c1.7-.3 2.3.2 1.8 2-.2.8-1.7 2.5.8 2.9.4.1-.4 2.6-.9 2.6-1.2 0-1.2.7-1.4 1.5-.6 2.6-1.2 5.2-1.7 7.8-.1.5-.4 1.2.2 1.4 1.9.7.9 2.2.4 2.8-.9 1.2-2.4.6-3.6.4-1.2-.3-1.7-1.2-1.4-2.4.6-2.8 1.2-5.5 1.8-8.2.2-.7.3-1.4.5-2.1.1-.4.3-.8-.3-1.1-.9-.5-1-2.5-.2-2.6 2-.2 1.6-1.8 1.8-2.9.2-1.6.5-2.7 2.2-2.1zm8.3 0c1.8-.4 2.1.2 1.7 1.8-.2.9-1.7 2.7.9 3-.3.9.2 2.3-1 2.5-1.2.2-1.3.9-1.5 1.6-.6 2.5-1.1 5.1-1.6 7.7-.1.5-.4 1.2.1 1.4 1.9.8 1 2.4.4 3-.9 1-2.4.6-3.6.2-1.3-.4-1.5-1.4-1.3-2.5.7-3.3 1.4-6.7 2.1-10 .2-.8.4-1.4-.7-1.5-.5-.1-.3-2.6.3-2.6 2 0 1.6-1.6 1.8-2.6.2-1.4.5-2.7 2.4-2zm-28.8-.9c-1.5 7.1-2.9 14-4.4 20.9-.3 1.2-3 2.1-4 1.3-.4-.3-.2-.7-.1-1.1 1.4-6.6 2.8-13.3 4.2-19.9.2-.8.5-1.3 1.4-1.2h2.9zm-48 7.7c1-1.2 2-2 3.2-2.4.8-.3 1.3-.1 1 .9-.2.6-.3 1.3-.4 1.9-.2 1.1-.5 1.8-1.9 1.8-1.9 0-2.6 1.5-3 3.1-.6 2.6-1.1 5.2-1.6 7.8-.2 1.1-3 2.1-3.9 1.3-.5-.4-.1-.9 0-1.3 1-4.7 2-9.4 3-14.2.5-2.2 2.1-.9 3.3-1.2.5 0 .6.2.3 2.3zm5.2 14.5c-1.7.4-1.9-.4-1.6-1.8 1-4.5 1.9-8.9 2.9-13.4.3-1.4 2.9-2.3 4-1.5.4.3.2.7.1 1.1-1 4.9-2.1 9.7-3 14.5-.4 1.6-1.6 1-2.4 1.1z",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6 409.1c.4.4 1.7-.8 1.6.8-.1 2.8-.6 3.3-2.7 3.3-.7 0-1.8.6-1.8-1 .2-2.5.6-3.1 2.9-3.1z",
    style: {
      fill: "#f7f5f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9 409.1c.4.4 1.7-.7 1.7.8-.1 2.6-.7 3.3-3 3.3-.7 0-1.7.5-1.6-1 .2-2.5.7-3.1 2.9-3.1z",
    style: {
      fill: "#f7f5fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9 394.4c.1-.5.1-.9.2-1.2.4-2.1 1.8-2.9 3.8-2.2.6.2.5.5.4.9-.1 2.4-.4 2.7-2.9 2.7-.4-.1-1-.1-1.5-.2z",
    style: {
      fill: "#fbfafc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1 254.1c-4.2 0-6-2.6-4.7-7.1 1-3.7 3.2-6.6 6.9-8.2 2.4-1 4.8-1.3 6.9.4 1.9 1.5 1.6 3.8 1.1 6-1.3 4.8-5.4 9.1-10.2 8.9zm-119.5 0c-3.8 0-5.3-1.7-5.1-5.4.3-4.9 5.4-10.9 10.8-10.5 2.7.2 4.5 1.5 4.6 4.2.4 4.7-3.9 11.9-10.3 11.7z",
    style: {
      fill: "#fef900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.8 189.5c-1.5.2-2.2-.1-1.2-2 .6-1.1.8-2.5 1.3-3.7.3-.8.2-2.1 1.2-2.3 1.3-.2 2.8-.4 4.1.2 1.2.5 1.3 1.7 1.1 2.9-.6 3-2.9 4.9-6.5 4.9z",
    style: {
      fill: "#fdf802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.2 197.4c2.5-4.4 5.2-8.2 7.4-12.4-.5 3.7-1 7.4-1.1 11.2 0 .9-.4 1.3-1.3 1.2h-5zm-175.7-13.1c-.8 3.9-1.2 7.9-1.4 11.8 0 .9-.3 1.3-1.3 1.3h-5c2.7-4.5 5.6-8.6 7.7-13.1z",
    style: {
      fill: "#fdf502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.7 308.3c1.3-2.4 2.5-4.4 3.8-6.7.9 2.2.8 4.1 1.1 6 .1.7-.4.7-.8.7h-4.1z",
    style: {
      fill: "#fbf605"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6 307c.1-5.4 4-8.6 8.8-7.6 1.8.4 2.5 1.5 2.9 3 .9 4.1-2.6 8.7-6.8 8.9-3.2.3-5-1.3-4.9-4.3zm-72.5-7.8c3.4 0 4.9 1.8 4.5 5.1-.8 6.1-5.4 7.9-9.1 6.7-1.3-.4-2.1-1.3-2.4-2.6-1.3-4.6 2.3-9.1 7-9.2z",
    style: {
      fill: "#fef801"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1 303.9h-.8c-3.1 0-3.2-.1-2.2-3 .2-.7.6-.9 1.2-.9 1.6 0 3.3-.1 4.9 0 .9 0 1.9.1 1.9 1.4 0 1.2-.4 2.2-1.8 2.3-1 .1-2.1.2-3.2.2z",
    style: {
      fill: "#fbf50b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.2 309.5c-2.3 0-4.5 0-6.8-.1 2.2-.5 4.5-.6 6.8.1z",
    style: {
      fill: "#5c4a05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 158.7c.9-2.1 2.5-3.1 4.7-3.1 2.4 0 4 1.3 4.9 3.5 0 1.1-.6 1.6-1.6 1.4-2.1-.5-4.2-.3-6.2-.4-.8-.1-2 .1-1.8-1.4z",
    style: {
      fill: "#fcd6d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 158.7c.2 1 1 .8 1.7.9 2.2.1 4.4-.4 6.5.5.8.3 1-.5 1.4-1 .8.9.8 2.1.7 3.2-.3.6-.8.9-1.4.7-2.3-.7-4.6 0-6.9.1-1.1.1-2.1 0-2.6-1.1-.2-1.2-.2-2.4.6-3.3z",
    style: {
      fill: "#fd9ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8 161.9c1.8 1.6 3.9.1 5.8.3 1.3.1 2.6-.4 3.9.4.4.3.9-.1 1.3-.3v1.9c-1.1 1.2-2.5 1.6-4.1 1.4-2-.2-4.2.5-6.1-.6-.9-.8-.9-1.9-.8-3.1z",
    style: {
      fill: "#fb6d72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6 165.1c1.6 0 3.1-.1 4.7 0 1.9 0 3.8.1 5.5-.8-1.1 2.6-2 3.4-4.8 3.2-2-.3-4.6.5-5.4-2.4z",
    style: {
      fill: "#f74146"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7 404.4c-.5 1.9-.7 3.2-1.2 4.5-.5 1.3-1.4 2.3-2.8 1.5-1.4-.8-.6-2.1 0-3.1.7-1.4 2.3-1.7 4-2.9z",
    style: {
      fill: "#503993"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4 404.5c-.2 1.9-.5 3.5-1.2 4.9-.5 1-1.4 1.5-2.4 1.1-1.2-.5-.8-1.5-.6-2.4.5-1.9 2.4-2.4 4.2-3.6z",
    style: {
      fill: "#513894"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4 408.2c.5-2.1 1.1-4.9 1.8-7.6.3-1.3 1.4-1.7 2.6-1.4 1.3.3 1 1.4.8 2.4-.5 2.2-.9 4.5-1.4 6.7-.2.9-.5 1.9-1.7 2.2-1.4.4-2.2-.2-2.1-2.3z",
    style: {
      fill: "#4e3593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1 401.2c-.6 2.4-1.2 5.2-1.9 8-.3 1.4-1.5 1.6-2.7 1.3-1.3-.3-1-1.4-.8-2.3l1.5-6.9c.2-1.1.7-2 1.9-2.2 1.3-.2 2 .3 2 2.1z",
    style: {
      fill: "#4e3691"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4 408.8c.6-2.7 1.1-5.4 1.8-8 .3-1.3 1.3-2 2.7-1.7 1.6.4 1 1.6.8 2.5-.5 2.5-1 5-1.7 7.4-.3 1.2-1.3 1.6-2.5 1.4-.9 0-1.2-.6-1.1-1.6z",
    style: {
      fill: "#4e3594"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1 385.3s54.1-31 160.3-32.9c0 0 100.4.6 158.8 34.5l-6.4 7.2s-62.9-33.4-151.5-32.9c0 0-103.3.5-153.8 32.4l-7.4-8.3z",
    style: {
      fill: "#39177f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabweQuick10);
export default __webpack_public_path__ + "static/media/zimbabwe_quick_10.5e23113ac7e83bf97249caf2f60a179f.svg";
export { ForwardRef as ReactComponent };